<template>
  <ManySearch />
</template>

<script>
import ManySearch from "@/components/common/views/search/ManySearch.vue";
export default {
    components:{
        ManySearch
    }
}
</script>